import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/system";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";

import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import RouterComp from "./routes/index";
import theme from "./theme";
import store from "./store/index";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer theme="colored" autoClose={1500}/>
      <Provider store={store}>
        <RouterComp />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
